export default {
    /* GET_USER_TASKS
    ---------------------------------------------------------------
    */
    GET_USER_TASKS_REQUEST: state => {
        state.userTasksLoading = true
    },
    GET_USER_TASKS_SUCCESS: (state, data) => {
        state.userTasks = data.results
        state.userTasksLoading = false
    },
    GET_USER_TASKS_FAILURE: state => {
        state.userTasksLoading = false
    },
    /* GET_USER_TASK_STATUSES
    ---------------------------------------------------------------
    */
    GET_USER_TASK_STATUSES_SUCCESS: (state, data) => {
        state.userTaskStatuses = data
    },
    SET_USER_TASK_FILTERS: (state, filters) => {
        state.filters = filters
    },
    CLEAR_USER_TASK_FILTERS: state => {
        state.filters = state.setInitialFilters()
    }
}